import {useQuery} from '@tanstack/react-query';
import {Link} from 'react-router-dom';
import {authHeaders,fetchImpl} from '../lib/api';
import {env} from '../lib/env';
import {day} from '../lib/format';
import {useT} from '../lib/i18n';

export interface Report {id:string;kind:'set_out'|'progress'|'completion'|'issue';reported_at:string;day_id:string|null;work_order_complete:boolean;notes:string;scope_description:string|null;checklist:Record<string,boolean>;photo_count:number}
export async function readReports(ref:string):Promise<Report[]>{
  if(env.mock)return [];
  const r=await fetchImpl(`${env.apiBase}/api/jobs/${encodeURIComponent(ref)}/completion-review`,{headers:await authHeaders()});
  const body=await r.json() as {data?:Report[];error?:string};
  if(!r.ok||!body.data)throw Error(body.error??`api ${r.status}`);
  return body.data;
}

export function JobCompletionReview({jobRef}:{jobRef:string}){
  const {t}=useT();
  const q=useQuery({queryKey:['job',jobRef,'completion-review'],queryFn:()=>readReports(jobRef)});
  return <section className="mt-3 border-t pt-3 text-sm" aria-label={t('job.completionReview')}>
    <h3 className="font-semibold">{t('job.completionReview')}</h3>
    {q.isPending&&<p role="status" className="mt-2 text-muted-foreground">…</p>}
    {q.isError&&<p role="alert" className="mt-2 text-destructive">{t('job.completionReviewError')}</p>}
    {q.data?.length===0&&<p className="mt-2 text-muted-foreground">{t('job.completionReviewEmpty')}</p>}
    {!!q.data?.length&&<ul className="mt-2 divide-y">{q.data.map(r=><li key={r.id} className="space-y-1 py-2">
      <p className="font-medium">{r.kind==='completion'?t('job.dayReport'):r.kind==='set_out'?t('job.setOutReport'):r.kind==='issue'?t('job.issueReport'):t('job.progressReport')} · {day(r.reported_at)}{r.work_order_complete?` · ${t('job.wholeWorkOrderReported')}`:''}</p>
      {r.kind==='completion'&&r.checklist.scope_completed&&<p>{t('job.scopeCompleted')}{r.scope_description?` · ${r.scope_description}`:''}</p>}
      {r.notes&&<p className="whitespace-pre-wrap">{r.notes}</p>}
      <p className="text-micro text-muted-foreground">{t('job.photoCount',{count:r.photo_count})}{r.day_id?` · ${r.day_id}`:''}</p>
    </li>)}</ul>}
    <Link className="mt-2 inline-block text-primary underline" to={`/archive?job=${encodeURIComponent(jobRef)}`}>{t('job.completionPhotos')}</Link>
  </section>;
}
